import { jsx as p, jsxs as f } from "react/jsx-runtime";
import { accordionBlueprint as M } from "./index-blueprint.es.js";
import * as h from "@radix-ui/react-accordion";
import { AngleDownIcon as R, AngleUpIcon as W } from "@made-people/blueprint-icons";
import { clsx as z } from "clsx";
import { withZod as H } from "@made-people/react-prop-guard";
import { withManagedProps as P } from "@made-people/managed-props";
import { headingSchema as k, Heading as B } from "@made-people/blueprint-heading";
import { componentWrapperSchema as D, ComponentWrapper as E } from "@made-people/blueprint-component-wrapper";
import { responsiveImageSchema as N, ResponsiveImage as n } from "@made-people/blueprint-responsive-image";
import { Markdown as O } from "@made-people/blueprint-markdown";
import T from "react";
import { z as o } from "zod";
import "@made-people/blueprint";
const U = ({
  content: a
}) => a ? typeof a == "string" ? /* @__PURE__ */ p(O, { content: a }) : T.isValidElement(a) ? a : null : null, V = o.object({
  content: o.object({
    value: o.string().optional(),
    content: o.custom().or(o.string()).optional(),
    trigger: o.custom().optional(),
    icon: N.optional(),
    forceMount: o.boolean().optional()
  }),
  /**
   * Item settings for the accordion. Includes disabeling the item, etc.
   */
  radixAccordionItemSettings: o.object({
    header: o.custom().optional(),
    content: o.custom().optional(),
    item: o.custom().optional(),
    trigger: o.custom().optional()
  }).optional()
}), Z = o.object({
  variants: o.custom().optional(),
  blueprint: o.custom().optional(),
  layout: D.shape.layout.optional(),
  /**
   * The items for the accordion including content with value, trigger and content.
   */
  items: o.array(V).optional(),
  /**
   * Accordion Heading
   */
  headerLeftImage: N.optional(),
  heading: k.optional(),
  icons: o.object({
    open: o.custom().optional(),
    close: o.custom().optional()
  }).optional(),
  /**
   * Global settings for the accordion.
   */
  radixAccordionSettings: o.object({
    root: o.union([
      o.custom(),
      o.custom()
    ]).optional(),
    header: o.custom().optional(),
    content: o.custom().optional(),
    item: o.custom().optional(),
    trigger: o.custom().optional()
  }).optional()
}), i = P(
  "Accordion",
  H(
    {
      schema: Z,
      defaultProps: {
        icons: {
          open: /* @__PURE__ */ p(R, {}),
          close: /* @__PURE__ */ p(W, {})
        },
        radixAccordionSettings: {
          root: {
            type: "single",
            collapsible: !0
          }
        }
      }
    },
    ({
      items: a,
      icons: r,
      radixAccordionSettings: l,
      variants: j,
      heading: s,
      layout: w,
      headerLeftImage: t,
      blueprint: C
    }) => {
      if (!(a != null && a.length))
        return null;
      const m = (C ?? M).styles(j);
      return /* @__PURE__ */ f(E, { layout: { ...w }, className: m.base, children: [
        (s == null ? void 0 : s.heading) && /* @__PURE__ */ f("div", { className: m.headerWrapper, children: [
          t && t.image && /* @__PURE__ */ p(
            n,
            {
              ...t,
              className: m.headerLeftImage,
              displaySize: "32px"
            }
          ),
          /* @__PURE__ */ p(B, { ...s, className: m.header })
        ] }),
        /* @__PURE__ */ p(h.Root, { type: "single", ...l == null ? void 0 : l.root, children: a.map(({ content: u, radixAccordionItemSettings: e }) => {
          var v, y, b;
          return /* @__PURE__ */ f(
            h.Item,
            {
              className: z("group overflow-hidden", m.item),
              value: u.value ?? ((v = u.trigger) == null ? void 0 : v.toString()) ?? "",
              ...l == null ? void 0 : l.item,
              ...e == null ? void 0 : e.item,
              children: [
                /* @__PURE__ */ p(
                  h.Header,
                  {
                    ...l == null ? void 0 : l.header,
                    ...e == null ? void 0 : e.header,
                    asChild: !0,
                    children: /* @__PURE__ */ f(
                      h.Trigger,
                      {
                        className: m.trigger,
                        ...l == null ? void 0 : l.trigger,
                        ...e == null ? void 0 : e.trigger,
                        children: [
                          u.icon && ((b = (y = u.icon) == null ? void 0 : y.initial) == null ? void 0 : b.src) && /* @__PURE__ */ p(
                            n,
                            {
                              ...u.icon,
                              className: m.icon
                            }
                          ),
                          u.trigger,
                          (r == null ? void 0 : r.close) && /* @__PURE__ */ p("div", { className: m.iconClose, children: r.close }),
                          (r == null ? void 0 : r.open) && /* @__PURE__ */ p("div", { className: m.iconOpen, children: r.open })
                        ]
                      }
                    )
                  }
                ),
                /* @__PURE__ */ p(
                  h.Content,
                  {
                    ...l == null ? void 0 : l.content,
                    ...e == null ? void 0 : e.content,
                    ...u.forceMount && { forceMount: !0 },
                    children: /* @__PURE__ */ p("div", { className: m.content, children: /* @__PURE__ */ p(U, { content: u.content }) })
                  }
                )
              ]
            },
            `accordion-item-${u.value ?? u.trigger}`
          );
        }) })
      ] });
    }
  )
);
export {
  i as Accordion,
  U as AccordionContent,
  V as accordionItemSchema,
  Z as accordionSchema
};
//# sourceMappingURL=index.es.js.map
